import Renderer from './Renderer';
import loadFont from './load-font';

export default {
    Renderer,
    loadFont
};